export default __webpack_public_path__ + "static/media/Media.98591110.svg";